// extracted by mini-css-extract-plugin
export var centerText = "_72-8";
export var container = "_72-0";
export var doughnutContainer = "_72-7";
export var legend = "_72-a";
export var legendItemColorDisplay = "_72-b";
export var legendItemLabel = "_72-d";
export var legendItemValue = "_72-c";
export var lg = "_72-5";
export var maxWidth = "_72-9";
export var md = "_72-4";
export var responsive = "_72-6";
export var sm = "_72-3";
export var xs = "_72-2";
export var xxs = "_72-1";